import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModuleBrief } from '../../config/modules.config';

@Component({
  selector: 'app-import-brief',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './import-brief.component.html',
  styleUrls: ['./import-brief.component.scss'],
})
export class ImportBriefComponent {
  @Input() brief!: ModuleBrief;
  @Input() requiredLabels?: string[];
}
